import { defineMessages } from 'react-intl';

export default defineMessages({
  connect: 'Connect',
  connectWallet: 'Connect wallet',
});
